import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";

import { MdOutlineAirplanemodeActive } from "react-icons/md";
import { BsCashCoin } from "react-icons/bs";
import { MdStars } from "react-icons/md";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { FaInfinity } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import FAQSchema from "../../FAQSchema";
import { motion } from "framer-motion";
import {
  FaListAlt,
  FaRegCreditCard,
  FaWpforms,
  FaRegCheckCircle,
  FaFileAlt,
  FaUserCheck,
  FaShippingFast,
} from "react-icons/fa";
import {
  FaSearch,
  FaFileUpload,
  FaEdit,
  FaHourglassHalf,
  FaCreditCard,
  FaExchangeAlt,
  FaPercent,
  FaMoneyBillWave,
  FaGlobe,
  FaGift,
  FaChartBar,
} from "react-icons/fa";

import {
  FaMedal,
  FaRegHandshake,
  FaHotel,
  FaReceipt,
  FaLayerGroup,
  FaGlobeAmericas,
  FaPhoneAlt,
  FaUtensils,
  FaGasPump,
} from "react-icons/fa";
import {
  FaMoneyCheckAlt,
  FaClipboardCheck,
  FaBalanceScale,
  FaWallet,
  FaTags,
} from "react-icons/fa";
import {
    FaChartLine,
    FaBriefcase,
    FaPiggyBank,
    FaSuitcaseRolling,
    FaTools,
  } from "react-icons/fa";
  import {
    FaBusinessTime,
    FaHandHoldingUsd,
    FaFolderOpen,
    FaPenNib,
    FaRegClock,
  
  } from "react-icons/fa";
  import {
    FaChartPie,
    FaBalanceScaleRight,
    FaPercentage,
    
    FaFileInvoiceDollar,
    FaUsersCog,
  
  } from "react-icons/fa";
  import {
    FaCheckCircle,
  
    FaPaperPlane,
    FaHourglassStart,
  
    FaHeart,
    FaGem,

    FaConciergeBell ,
    FaHeartbeat,
    FaStar ,
    FaHeadset
  } from "react-icons/fa";
import { FaShieldAlt, FaPlaneDeparture, FaCoins } from "react-icons/fa";
import { BadgeCheck, FileText } from "lucide-react";
import AdBanner from "../AdPage/AdBanner";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}
const  LifeStyleCreditCard = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  // const location = useLocation()
  // console.log(location.state)
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
        // console.log("Card API Response:", res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((cards) => cards.category_name === "Lifestyle ")
    .slice(indexOfFirstCard, indexOfLastCard);
  console.log({ currentCards });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
        question: "What is a Lifestyle Credit Card?",
        answer: "A Lifestyle Credit Card is designed to offer rewards, discounts, and exclusive benefits on lifestyle-related spending, such as shopping, dining, and travel.",
      },
      {
        question: "How do I apply for a Lifestyle Credit Card?",
        answer: "You can apply online or at a bank branch by submitting necessary documents such as proof of identity, address, and income.",
      },
      {
        question: "What are the rewards on a Lifestyle Credit Card?",
        answer: "Rewards typically include points for shopping, dining, travel, and wellness-related expenses, which can be redeemed for products, services, or discounts.",
      },
      {
        question: "Is there an annual fee for Lifestyle Credit Cards?",
        answer: "Yes, most Lifestyle Credit Cards have an annual fee, though it’s usually justified by the perks and rewards they offer.",
      },
      {
        question: "Can I get a Lifestyle Credit Card with a low credit score?",
        answer: "Lifestyle Credit Cards usually require a good to excellent credit score (750+). Applicants with lower scores may find it difficult to qualify.",
      },
      {
        question: "What benefits come with a Lifestyle Credit Card?",
        answer: "These cards offer benefits such as dining privileges, shopping discounts, travel perks, fitness memberships, and access to exclusive events.",
      },
      {
        question: "Can I earn rewards for every purchase?",
        answer: "Yes, Lifestyle Credit Cards reward you for all purchases, but you’ll earn more points on categories like shopping, dining, and travel.",
      },
      {
        question: "Do Lifestyle Credit Cards offer travel insurance?",
        answer: "Many Lifestyle Credit Cards offer complimentary travel insurance covering trip cancellations, delays, lost baggage, and medical emergencies.",
      },
      {
        question: "Are there any dining privileges with these cards?",
        answer: "Yes, Lifestyle Credit Cards typically offer discounts at top restaurants, exclusive dining offers, and even special events for cardholders.",
      },
      {
        question: "Can I use a Lifestyle Credit Card for international purchases?",
        answer: "Yes, most Lifestyle Credit Cards are accepted globally, but you should check for foreign transaction fees.",
      },
      {
        question: "What is concierge service?",
        answer: "Concierge services assist with booking travel, finding dining reservations, and fulfilling luxury requests for cardholders.",
      },
      {
        question: "Are there any wellness benefits with these cards?",
        answer: "Some cards offer wellness-related benefits such as gym memberships, discounts on health services, or spa packages.",
      },
      {
        question: "Can I get a Lifestyle Credit Card if I’m a student?",
        answer: "Most Lifestyle Credit Cards require applicants to be employed or have a stable income, so they may not be suitable for students unless they meet the eligibility criteria.",
      },
      {
        question: "What should I look for when choosing a Lifestyle Credit Card?",
        answer: "Consider the rewards structure, annual fee, partner discounts, and additional perks such as concierge services or travel benefits.",
      },
      {
        question: "How can I redeem my reward points?",
        answer: "Reward points can usually be redeemed for travel vouchers, shopping discounts, or even cashback, depending on the card’s reward program.",
      },
      {
        question: "Can I apply for multiple Lifestyle Credit Cards?",
        answer: "Yes, but it’s important to manage multiple cards responsibly to avoid high debt and interest charges.",
      },
      {
        question: "What happens if I miss a payment on my Lifestyle Credit Card?",
        answer: "Missing payments can result in late fees, higher interest rates, and a negative impact on your credit score.",
      },
      {
        question: "Do Lifestyle Credit Cards offer any exclusive event access?",
        answer: "Yes, many Lifestyle Credit Cards offer exclusive invitations to events like concerts, fashion shows, and VIP experiences.",
      },
      {
        question: "What is the credit limit on a Lifestyle Credit Card?",
        answer: "The credit limit depends on the issuer’s evaluation of your income and creditworthiness but generally offers a higher limit for premium cardholders.",
      },
      {
        question: "Are there lifestyle credit cards with no annual fee?",
        answer: "Some cards offer no annual fee options, but they may not provide as many premium benefits as the higher-fee cards.",
      }
    ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  const steps = [
   
    {
      icon: <FaCheckCircle className="h-6 w-6 text-purple-600" />,
      title: "Check Eligibility Requirements",
      description:
        "   Verify that you meet the eligibility criteria, including age, income, and credit score, as required by the issuer for application.",
    },
    {
      icon: <FaFileAlt className="h-6 w-6 text-teal-500" />,
      title: "Gather Your Documents ",
      description:
        "   Prepare the necessary documents such as proof of identity, proof of address, income proof, and credit history.",
    },

    {
      icon: <FaPaperPlane className="h-6 w-6 text-pink-500" />,
      title: " Submit Your Application",
      description:
        " Complete the application form online or at the bank branch with the required details about your personal information and financial situation.",
    },

    {
      icon: <FaHourglassStart className="h-6 w-6 text-green-500" />,
      title: "Wait for Approval",
      description:
        "   The bank will review your application and credit profile to determine if you qualify for the card. You’ll be notified of the decision once the assessment is complete.",
    },
    {
        icon: <FaCreditCard  className="h-6 w-6 text-green-500" />,
        title: "Receive Your Card",
        description:
          "   If approved, the Lifestyle Credit Card will be sent to your registered address. Follow the instructions to activate the card and begin enjoying its benefits.",
      },
      {
        icon: <FaHeart className="h-6 w-6 text-blue-600" />,
        title: "Identify Your Lifestyle Preferences",
        description:
          "  Evaluate your lifestyle needs—whether you want rewards for shopping, dining, travel, or entertainment—and identify which type of lifestyle credit card suits you best.",
      },
      {
        icon: <FaBalanceScale className="h-6 w-6 text-amber-500" />,
        title: " Compare Lifestyle Credit Cards",
        description:
          " Research the available lifestyle credit cards to compare their benefits, such as reward points, cashback, and partner discounts, ensuring they align with your spending habits.",
      },
  ];
  const benefits = [
    {
      icon: <FaConciergeBell className="text-3xl text-red-500" />,
      title: "  Concierge Services",
      description:
        "   Many premium Lifestyle Credit Cards come with personalized concierge services, assisting with booking travel, finding dining reservations, and other luxury lifestyle needs.",
    },
    {
        icon: <FaHeartbeat  className="text-3xl text-green-500" />,
        title: "Fitness and Wellness Benefits",
        description:
          "   Some lifestyle cards offer wellness programs, gym memberships, and discounts on health and fitness-related services, promoting a balanced lifestyle.",
      },
      {
        icon: <FaStar className="text-3xl text-yellow-500" />,
        title: "  Event Invitations and VIP Access",
        description:
          "  Get invited to exclusive events, concerts, fashion shows, and VIP experiences as part of your cardholder privileges, elevating your social lifestyle.",
      },
      {
        icon: <FaShieldAlt className="text-3xl text-blue-500" />,
        title: " Travel Insurance and Protection",
        description:
          "  Many Lifestyle Credit Cards come with complimentary travel insurance, covering trip cancellations, lost baggage, medical emergencies, and more during your travels.",
      },
      {
        icon: <FaTags className="text-3xl text-amber-600" />,
        title: "Exclusive Shopping Discounts",
        description:
          " Many Lifestyle Credit Cards offer exclusive discounts and offers at leading fashion retailers, beauty stores, and online marketplaces, helping you save on your favorite brands.",
      },
  
      {
        icon: <FaUtensils className="text-3xl text-purple-600" />,
        title: "Dining Privileges",
        description:
          "   Enjoy discounts at top-tier restaurants, cafes, and dining chains. Lifestyle credit cards often come with dining programs that allow cardholders to earn discounts or cashback on dining expenses.",
      },
      {
        icon: <FaPlaneDeparture className="text-3xl text-pink-500" />,
        title: "Travel Perks",
        description:
          " For travel enthusiasts, these cards provide access to exclusive deals such as discounted airfare, hotel bookings, and travel packages. Some cards even offer airport lounge access for a premium travel experience.",
      },
      {
        icon: <FaGem className="text-3xl text-yellow-500" />,
        title: "Reward Points on Everyday Spending",
        description:
          " Lifestyle cards reward you for your daily purchases—whether you’re buying groceries, paying bills, or shopping online. Earn points for every transaction, which can be redeemed for products, services, or even travel vouchers.",
      },
  ];

  const factors = [
    {
        icon: FaStar,
        title: "Rewards Structure",
        desc: "Look for a card that offers reward points for the categories you spend most on, such as shopping, dining, or travel. Some cards provide bonus points for particular types of purchases, making it easier to earn more rewards.",
      },
      {
        icon: FaWallet,
        title: "Annual Fee",
        desc: "Lifestyle credit cards often come with an annual fee. While some offer no-fee options, others may have higher fees but provide more substantial benefits. Weigh the annual fee against the value of the rewards and perks.",
      },
      {
        icon: FaTags,
        title: "Partner Discounts and Offers",
        desc: "Check for card benefits that offer exclusive discounts or special offers with lifestyle brands, airlines, or hotels. These partnerships can significantly enhance the value of your card.",
      },
      {
        icon: FaHeadset,
        title: "Customer Service and Support",
        desc: "Ensure that the issuer provides top-tier customer service, especially for premium cards. 24/7 support, quick responses, and efficient dispute resolution should be a priority.",
      },
      {
        icon: FaGift,
        title: "Additional Perks",
        desc: "Look for other lifestyle-related perks such as access to airport lounges, concierge services, and wellness programs. The more perks, the better the overall experience of owning the card.",
      },
      {
        icon: FaPercentage,
        title: "Interest Rates and Fees",
        desc: "Even with great rewards, you should carefully review the card’s interest rates for outstanding balances. Opt for cards with competitive interest rates if you plan on carrying a balance occasionally.",
      },
      {
        icon: FaCreditCard,
        title: "Credit Limit",
        desc: "A higher credit limit is often associated with premium Lifestyle Credit Cards. Consider your financial needs and spending habits when choosing a card with a sufficient credit limit.",
      },
  ];
  return (
    <>
      <Helmet>
        <title>
        Top Lifestyle Credit Cards in India – Dining, Movies & More
        </title>
        <meta
          name="description"
          content="Discover the best lifestyle credit cards offering benefits on dining, entertainment, shopping & travel. Compare and apply online."
        />
     
        <link
          rel="canonical"
          href="https://thefinmaster.com/credit-card/lifestyle-credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className="w-full flex flex-col items-center ">
        <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
          <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
            LifeStyle Credit Card
          </h1>
          <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
            Experience financial freedom and flexibility with our credit card
            options.
          </p>
        </div>

        <div className="flex flex-wrap   justify-center gap-4 lg:gap-6 mt-4">
          <Link
            to="/credit-card/best-cashback-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsCashCoin className="mr-2 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Cash Back
              </span>
            </span>
          </Link>

          <Link
            to="/credit-card/travel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdOutlineAirplanemodeActive className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Travel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/fuel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsFillFuelPumpFill className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Fuel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-lifetime-free-credit-cards"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaInfinity className="mr-4 text-2xl text-black" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Lifetime Free
              </span>
            </span>
          </Link>
          <Link to="/credit-card/best-premium-credit-card"  className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group">
                    <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                    <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                    <svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                    </span>
                    <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                    <svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                    </span>
                    <span className="relative flex items-center"><MdStars className="mr-1 text-black text-2xl" /> <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">Premium</span></span>
                    </Link>
                    <Link
                    to="/credit-card/reward-credit-card"
                    className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                  >
                    <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                    <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                      <svg
                        class="w-5 h-5 text-green-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        ></path>
                      </svg>
                    </span>
                    <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                      <svg
                        class="w-5 h-5 text-green-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        ></path>
                      </svg>
                    </span>
                    <span className="relative flex items-center">
                      <FaGift className="mr-1 text-black text-2xl" />{" "}
                      <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                      Reward
                      </span>
                    </span>
                  </Link>
                  <Link
                    to="/credit-card/business-credit-card"
                    className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
                  >
                    <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
                    <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                      <svg
                        class="w-5 h-5 text-green-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        ></path>
                      </svg>
                    </span>
                    <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                      <svg
                        class="w-5 h-5 text-green-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        ></path>
                      </svg>
                    </span>
                    <span className="relative flex items-center">
                      <FaBriefcase className="mr-1 text-black text-2xl" />{" "}
                      <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                      Business
                      </span>
                    </span>
                  </Link>
                 
        </div>
        <h2 className="text-center font-bold text-2xl md:text-3xl my-10">
          Featured Credit Cards
        </h2>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 w-full h-[350px] flex flex-col justify-between">
              {/* <div className="w-[70%] mx-auto">
                                                <h2 className="text-center font-medium pt-5 text-lg">
                                                  <span className="font-semibold text-white">816 people</span>{" "}
                                                  are on call with our advisors right now
                                                </h2>
                                              </div> */}
              <div className="w-full mx-auto">
                {/* <Link
                  to="https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                > */}
                  <div className="w-[80%] mx-auto ">
                 <AdBanner displayOrder="2" />
                    {/* <img
                      src="/assets/ppp.png"
                      alt="Advertisement"
                      target="_blank"
                      rel="noopener noreferrer"
                    /> */}
                  </div>
                {/* </Link> */}
                <div className="bg-white">
                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                    Know your advisor
                                                  </h3> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>
      </div>

      <div className="flex justify-center items-center  p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center ">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 ">
          What is a Lifestyle Credit Card?
          </h2>
          <p className="text-gray-600 leading-relaxed">
          A Lifestyle Credit Card is specifically designed to enhance the everyday living of cardholders by offering rewards and benefits tailored to lifestyle expenses. Whether it’s for shopping, dining, entertainment, travel, or wellness, this card provides exclusive perks that cater to various facets of modern living. Beyond simply making purchases, a Lifestyle Credit Card enriches your lifestyle with rewards, discounts, and privileges that make everyday activities more enjoyable. It’s perfect for those who seek more from their credit card, turning everyday spending into opportunities for rewards and experiences that enhance the quality of life.
          </p>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          📝 How to Apply for a Lifestyle Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a Premium Credit Card is an easy yet
          eligibility-dependent process. Here's how to go about it:
        </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
        </div>
      <div className="w-full px-2 py-6 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-6xl mx-auto grid gap-10">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <FileText className="w-8 h-8 text-sky-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
              Documents Required to Apply for a Lifestyle Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Proof of Identity
                </span>
                <span>
                  {" "}
                  Government-issued ID, such as a passport, driver’s license, or Aadhaar card.

                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Proof of Address
                </span>
                <span>
                  {" "}
                  Utility bills, rental agreements, or bank statements showing your current address.

                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Income Proof
                </span>
                <span>
                  {" "}
                  Salary slips, bank statements, or income tax returns (ITR) to verify your financial standing.

                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Credit History
                </span>
                <span>
                  {" "}
                  A good credit score is essential for most Lifestyle Credit Cards; the bank may request credit reports for assessment.


                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Photographs
                </span>
                <span>
                  {" "}
                  Passport-sized photographs for identity verification.

                </span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Application Form
                </span>
                <span>
                  {" "}
                  Completed application form with all required personal details.

                </span>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <BadgeCheck className="w-8 h-8 text-emerald-600" />
              <span className="text-2xl md:text-3xl font-extrabold text-gray-800 dark:text-white">
              Eligibility Required to Get a Lifestyle Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                  {" "}
                  Age
                </span>
                <span>
                  {" "}
                  Typically, the applicant must be between 21 and 60 years old.

                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Income{" "}
                </span>
                <span> A stable income with a minimum monthly salary (varies by issuer) is required. For premium cards, the required income may be higher.

                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Credit Score
                </span>
                <span>  A good to excellent credit score (usually 750+) is preferred, though some cards may offer flexibility for those with lower scores.

</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Employment
                </span>
                <span>
                  {" "}
                  Applicants should be either salaried or self-employed with a steady income stream.

                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block font-semibold text-gray-900 dark:text-white">
                Residence Status
                </span>
                <span>
                  {" "}
                  Indian residents or NRIs may be eligible for a Lifestyle Credit Card, depending on the issuer's policies.

                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto mt-4">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center mb-10">
        Benefits of a Business Credit Card
        </h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-white shadow-md rounded-xl p-6 flex flex-col items-start gap-4 hover:shadow-xl transition duration-300"
            >
              {item.icon}
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-gray-600 text-md">{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6">
        How to Choose the Best Business Credit Card - Key Factors to Consider{" "}
        </h2>
        {/* <p className="text-gray-600 text-base md:text-lg text-center max-w-2xl mx-auto mb-12">
    Selecting the right fuel credit card goes beyond just fuel discounts. It’s about ensuring consistent savings, ease of use, and long-term value. Here are the key elements to evaluate before making your choice:
  </p> */}

        <div className="space-y-10 divide-y divide-gray-300">
          {factors.map((item, index) => (
            <div key={index} className="flex items-start gap-5 pt-8">
              <div className="text-blue-600 shrink-0">
                <item.icon size={32} className="mt-1.5" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-6 text-gray-800">
        {/* Section Title */}
        {/* Section Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">
        Why Opt for a Lifestyle Credit Card?
        </h2>

        <p className="text-base md:text-md text-center mb-14 max-w-4xl mx-auto text-gray-800">
        A Lifestyle Credit Card is ideal for individuals who want to enjoy the finer aspects of life—whether it’s shopping, dining, travel, or wellness. It’s perfect for those who appreciate rewards and benefits that align with their lifestyle choices. If you spend frequently on dining, entertainment, and travel, a Lifestyle Credit Card can help you save on these activities while giving you access to premium perks. Moreover, for those who enjoy exclusive access to events or luxury services, this card provides a level of sophistication that enhances everyday living. Whether you're a frequent traveler, foodie, or fitness enthusiast, a Lifestyle Credit Card can complement your passions and provide unmatched value.

        </p>

        {/* Comparison Table */}
        <h3 className="text-2xl md:text-3xl font-semibold text-center mb-8">
        Comparison Between Lifestyle Credit Cards and Regular Credit Cards
        </h3>
        {/* Styled Table */}
        <div className="overflow-x-auto w-full">
          <table className="min-w-[600px] border-separate border-spacing-y-2 text-left text-base text-gray-700">
            {/* Mobile-Friendly Table Alternative */}
            <div className="space-y-6 md:hidden">
              {[
                [
                  "Rewards",
                  "Enhanced rewards for lifestyle-related purchases (shopping, dining, travel)",
                  "Basic rewards or cashback for everyday purchases",
                ],
                [
                  "Perks",
                  "Premium perks like concierge services, dining discounts, and travel offers",
                  "Limited or no extra perks",
                ],
                [
                  "Annual Fee",
                  "Higher annual fees, typically justified by rewards and benefits",
                  "Generally lower annual fees",
                ],
                [
                  "Interest Rates",
                  "May have higher interest rates for premium features",
                  "Standard interest rates",
                ],
                [
                  "Target Audience",
                  "Individuals with a high discretionary spending on lifestyle activities",
                  "General consumers seeking basic credit facilities",
                ],
                [
                    "Customer Support",
                    "Priority customer service with personalized assistance",
                    "TStandard customer service",
                  ],
              ].map(([feature, fuel, regular], i) => (
                <div
                  key={i}
                  className="border rounded-xl p-4 shadow-sm bg-white"
                >
                  <p className="font-semibold text-gray-800 mb-2">{feature}</p>
                  <div className="text-sm text-gray-700">
                    <p>
                      <span className="font-semibold">
                      Lifestyle Credit Card:
                      </span>{" "}
                      {fuel}
                    </p>
                    <p>
                      <span className="font-semibold">Regular Credit Card

:</span>{" "}
                      {regular}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto">
              <table className="min-w-full border-separate border-spacing-y-2 text-left text-base text-gray-700">
                <thead className="bg-blue-50 text-gray-800">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Feature</th>
                    <th className="px-4 py-3 font-semibold">
                    Lifestyle Credit Card
                    </th>
                    <th className="px-4 py-3 font-semibold">
                    Regular Credit Card


                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    [
                        "Rewards",
                        "Enhanced rewards for lifestyle-related purchases (shopping, dining, travel)",
                        "Basic rewards or cashback for everyday purchases",
                      ],
                      [
                        "Perks",
                        "Premium perks like concierge services, dining discounts, and travel offers",
                        "Limited or no extra perks",
                      ],
                      [
                        "Annual Fee",
                        "Higher annual fees, typically justified by rewards and benefits",
                        "Generally lower annual fees",
                      ],
                      [
                        "Interest Rates",
                        "May have higher interest rates for premium features",
                        "Standard interest rates",
                      ],
                      [
                        "Target Audience",
                        "Individuals with a high discretionary spending on lifestyle activities",
                        "General consumers seeking basic credit facilities",
                      ],
                      [
                          "Customer Support",
                          "Priority customer service with personalized assistance",
                          "TStandard customer service",
                        ],
                  ].map(([feature, fuel, regular], i) => (
                    <tr
                      key={i}
                      className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3 font-medium">{feature}</td>
                      <td className="px-4 py-3">{fuel}</td>
                      <td className="px-4 py-3">{regular}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </table>
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default LifeStyleCreditCard;
